import { ODataOptions } from '../util/ODataBuilder';
import BaseApi from './BaseApi';

import OfficeModel from '../models/Office';

export interface IOffice {
    getAll(options: ODataOptions, jwt: string): Promise<object>;
    getById(id: number, jwt: string): Promise<object>;
    create(office: OfficeModel, jwt: string): Promise<object>;
    update(office: OfficeModel, jwt: string): Promise<object>;
    delete(id: number, jwt: string): Promise<object>;
}

export default class Office extends BaseApi implements IOffice {
    constructor(baseUrl: string) {
        super(baseUrl);

        this.getAll = this.getAll.bind(this);
        this.getById = this.getById.bind(this);
        this.create = this.create.bind(this);
        this.update = this.update.bind(this);
        this.delete = this.delete.bind(this);
    }

    public getAll(options: ODataOptions, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/officelocations${options.toString()}`, jwt);
    }

    public getById(id: number, jwt: string) {
        return this.getRequest(`${this.baseUrl}v1.0/officelocations/${id}`, jwt);
    }

    public create(office: OfficeModel, jwt: string) {
        return this.postRequest(`${this.baseUrl}v1.0/officelocations`, office, jwt);
    }

    public update(office: OfficeModel, jwt: string) {
        return this.putRequest(`${this.baseUrl}v1.0/officelocations/${office.id}`, office, jwt);
    }

    public delete(officeId: number, jwt: string) {
        return this.deleteRequest(`${this.baseUrl}v1.0/officelocations/${officeId}`, {}, jwt);
    }
}



// WEBPACK FOOTER //
// ./src/api/Office.ts